/**
 * Checks for a date string to be a valid date to avoid errors
 * @param { String } dateString
 * @returns { Boolean }
 */
export function isValidDate(dateString) {
	return dateString instanceof Date && !isNaN(dateString);
}
